import { ExportReq, HttpService, Records } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  ApplyPageReq,
  ApplyPageResp,
  ApplySimpleRecord,
  ApplyDetailResp,
  ApplyReq,
  MaterialRecord,
  MaterialPageReq,
  MaterialPageResp,
} from "./apply.interface";

export class ApplyService {
  static usePageApi() {
    const api = (params: ApplyPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_apply/page",
        params,
      });
    return HttpService.usePagination<ApplyPageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params,url='/purchase_apply/simple/list') =>
      HttpService.axios({
        method: "GET",
        url: url,
        params,
      });
    return HttpService.useRequest<Records<ApplySimpleRecord>>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/purchase_apply/${id}`,
      });
    return HttpService.useRequest<ApplyDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ApplyReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_apply",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ApplyReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/purchase_apply/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/purchase_apply/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_apply/export",
        data: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useMaterialPageApi() {
    const api = (params: MaterialPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_contract/list/material",
        params,
      });
    return HttpService.usePagination<MaterialPageResp>(api);
  }

  static useMaterialImportApi() {
    const api = (url: string, id: string) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_apply/import/detail",
        data: { url, id },
      });
    return HttpService.useRequest<Records<MaterialRecord>>(api);
  }

  static useMaterialExportApi() {
    const api = (id: string, applicationNo) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_apply/export/detail",
        data: { ids: [id], applicationNo },
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static validDetail(list: MaterialRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!(item.materialName && item.currentApplyCount && item.demandTime)) {
        valid = false;
        break;
      }
    }
    return valid;
  }
  static applyNewAdd() {
    const api = (data: ApplyReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_apply/add_new",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }
}
